import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Map } from 'immutable';
import { selectOptions } from '../ActiveGame/selectors';
import { Button, Muted } from '../Controls';
import PickSteps from '../Picks/PickSteps';
import { startPicks, submitPicks } from '../Picks/actions';
import { TRAINER } from '../Picks/constants';
import { selectPicksSource, selectSubmittingPicks } from '../Picks/selectors';
import { AT_ONCE, trainerPlay } from './trainerPlay';

/**
 * Playing a Trainer card from your hand: straight away when it picks nothing (Bill), otherwise one step at a time,
 * tapping a Pokémon (yours or the opponent's) or choosing cards here. Greyed out with the server's reason when it
 * can't be played.
 */
const TrainerMenu = ({ card }) => {
  const dispatch = useDispatch();
  const options = useSelector(selectOptions);
  const submitting = useSelector(selectSubmittingPicks);
  const picksSource = useSelector(selectPicksSource);

  const position = card.get('order');
  if (picksSource && picksSource.get('kind') === TRAINER && picksSource.get('handPosition') === position) {
    return <PickSteps />;
  }

  const { how, reason, source, steps } = trainerPlay(card, options);
  const play = how === AT_ONCE ? () => dispatch(submitPicks(source)) : () => dispatch(startPicks(source, steps));

  return (
    <>
      <Button $primary onClick={play} disabled={!!reason || submitting}>
        Play {card.get('name')}
      </Button>
      {reason && <Muted>{reason}</Muted>}
    </>
  );
};

TrainerMenu.propTypes = {
  card: PropTypes.instanceOf(Map).isRequired,
};

export default TrainerMenu;
